var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"width":"730","title":"选择坐标点"},on:{"on-ok":_vm.handleSelect},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('div',{ref:"map",staticStyle:{"width":"700px","height":"450px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }